module.exports = __webpack_public_path__ + "media/images/slider-1-e685cfe1aa98ee444c2ddfb5e904aed4.jpg";